<template>
  <form id="create_firmware_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن دستگاه</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>ورژن</label>
              <input
                type="text"
                name="code"
                v-model="form.version"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>فایل</label>
              <div></div>
              <div class="custom-file">
                <input
                  type="file"
                  class="custom-file-input"
                  id="file"
                  ref="file"
                  @change="fileChanged"
                  accept=".png, .jpg, .jpeg, .zip, .rar, .csv, .txt"
                />
                <label class="custom-file-label" for="file"></label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>نوع</label>
          <div class="radio-inline">
            <label
              v-for="type in deviceTypes"
              :key="`type-${type}`"
              class="radio"
            >
              <input
                type="radio"
                name="plan"
                :value="type"
                v-model="form.type"
              />
              <span></span>
              {{ typesTrans[type] }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";
import { STORE_ADMIN_FIRMWARE } from "@/core/services/store/admin/firmwares.module";

export default {
  name: "firmwares-create",
  data() {
    return {
      form: {
        version: "",
        type: 1,
        file: ""
      }
    };
  },
  components: {},
  mounted() {
    this.setBreadcrumbs();
    this.setActions();

    this.eventHub.$on("save-firmware-event", this.save);

    this.fv = formValidation(document.getElementById("create_firmware_form"), {
      fields: {
        code: {
          validators: {
            notEmpty: {
              message: "کد الزامی است"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off("save-firmware-event");
    // document.getElementById("save-firmware-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["deviceTypes", "typesTrans"])
  },
  methods: {
    setBreadcrumbs() {
      let items = [];

      if (this.$route.query.firmware) {
        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });

        items.push({
          title: "سیستم عامل ها",
          route: { name: "admin-firmwares-index" }
        });
      }

      items.push({ title: "افزودن سیستم عامل" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "save-firmware-event",
            class: "btn-primary",
            id: "save-firmware-btn"
          }
        ],
        links: [
          {
            name: "بازگشت",
            to: {
              name: "admin-firmwares-index",
              params: { id: this.$route.query.firmware }
            }
          }
        ]
      });
    },
    fileChanged(e) {
      if (e.target.files && e.target.files[0]) {
        e.target.nextElementSibling.innerHTML = e.target.files[0].name;
        e.target.nextElementSibling.classList.add("selected");
      } else {
        e.target.nextElementSibling.innerHTML = "";
        e.target.nextElementSibling.classList.remove("selected");
      }
    },
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-firmware-btn");
          this.disableBtn(submitBtn);
          let formData = new FormData();
          formData.append("type", this.form.type);
          formData.append("version", this.form.version);

          if (this.$refs.file.files && this.$refs.file.files[0]) {
            formData.append("file", this.$refs.file.files[0]);
          }
          this.$store
            .dispatch(STORE_ADMIN_FIRMWARE, formData)
            .then(() => {
              this.$router.push({
                name: "admin-firmwares-index",
                params: { id: this.$route.params.id },
                query: this.$route.query
              });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    }
  }
};
</script>
